import {SaveSaleVehicleFinancingBody} from '@dms/api/vehicle';

import {hasValidActiveRateMatrixCell} from '../hasValidActiveRateMatrixCell';

export function hasValidActiveFinancingCell(body: SaveSaleVehicleFinancingBody) {
  return hasValidActiveRateMatrixCell(
    body.rateMatrix.cells,
    (cell) =>
      cell.term === body.activeTerm &&
      cell.downPayment === body.activeDownPayment &&
      cell.balloonPayment === body.activeBalloonPayment
  );
}
